var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.initiated ? _c(_vm.SkinComponent, {
    tag: "component",
    attrs: {
      "code": _vm.code
    },
    model: {
      value: _vm.application,
      callback: function ($$v) {
        _vm.application = $$v;
      },
      expression: "application"
    }
  }) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }